import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ViewColumnsIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTCard, WPQTCardDataItem } from "../../../../components/Card/Card";
import { TaskCardActions } from "../../../../components/Card/TaskCardActions";
import { ArchivedTaskDropdown } from "../../../../components/Dropdown/ArchivedTaskDropdown/ArchivedTaskDropdown";
import { UserAssignementDropdown } from "../../../../components/Dropdown/UserAssignementDropdown/UserAssignementDropdown";
import { ADD_ASSIGNED_USER_TO_ARCHIVED_TASK, CHANGE_ARCHIVED_TASK_DONE_STATUS, OPEN_EDIT_TASK_MODAL, REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK, } from "../../../../constants";
import { ArchiveContext } from "../../../../providers/ArchiveContextProvider";
import { ModalContext } from "../../../../providers/ModalContextProvider";
function ArchiveItem({ task }) {
    const { modalDispatch } = useContext(ModalContext);
    const { archiveDispatch } = useContext(ArchiveContext);
    return (_jsxs(WPQTCard, { title: task.name, description: task.description, dropdown: _jsx(ArchivedTaskDropdown, { task: task }), className: "wpqt-cursor-pointer", onClick: () => {
            modalDispatch({
                type: OPEN_EDIT_TASK_MODAL,
                payload: { taskToEdit: task },
            });
        }, children: [_jsx(WPQTCardDataItem, { label: __("Board", "quicktasker"), value: task.pipeline_name
                    ? task.pipeline_name
                    : __("Board is deleted!", "quicktasker"), icon: _jsx(ViewColumnsIcon, { className: "wpqt-size-5 wpqt-icon-blue" }) }), _jsx(UserAssignementDropdown, { menuBtnClasses: "wpqt-self-start", task: task, onUserAdd: (user) => {
                    archiveDispatch({
                        type: ADD_ASSIGNED_USER_TO_ARCHIVED_TASK,
                        payload: { taskId: task.id, user },
                    });
                }, onUserDelete: (user) => {
                    archiveDispatch({
                        type: REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK,
                        payload: { taskId: task.id, user },
                    });
                } }), _jsx(TaskCardActions, { task: task, onDoneStatusChange: (taskId, done) => {
                    archiveDispatch({
                        type: CHANGE_ARCHIVED_TASK_DONE_STATUS,
                        payload: { taskId, done },
                    });
                } })] }));
}
export { ArchiveItem };
